import { Box } from '@mui/material'
import { startCase } from 'lodash'

interface RecipeDetailTableProps {
  tableKey: any[]
  providedInputNames: string[]
  recipeOutput: any
}
function RecipeDetailTable({
  tableKey,
  providedInputNames,
  recipeOutput,
}: RecipeDetailTableProps) {
  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        overflowY: 'auto',
        padding: 4,
        background: 'linear-gradient(98deg, #232323 0%, #1A1A1A 100%)',
        borderRadius: 4,
        height: '100%',
      }}
    >
      <table
        style={{
          width: '100%',
          borderCollapse: 'collapse',
        }}
      >
        <tbody>
          {tableKey?.map((key, index) => {
            const response = Array.isArray(recipeOutput?.provided_input[key])
              ? recipeOutput?.provided_input[key]?.join(', ')
              : recipeOutput?.provided_input[key]
            return (
              <tr key={index}>
                {recipeOutput.provided_input[key] && (
                  <th style={{ padding: 8, textAlign: 'left' }}>
                    {providedInputNames?.[key] ||
                      startCase(key?.replace('_', ' '))}
                  </th>
                )}
                {recipeOutput.provided_input[key] && (
                  <td style={{ padding: 8, textAlign: 'left' }}>{response}</td>
                )}
              </tr>
            )
          })}
        </tbody>
      </table>
    </Box>
  )
}

export default RecipeDetailTable
